export default {
  computed: {
    isPermitted() {
      return (permission) => this.$store.getters['auth/isPermitted'](permission);
    },
  },
};
